import styled from 'styled-components'
import { Col, Row, Button } from 'antd';

const Container = styled(Row)`
    height: 64px;
    .title, .nav{
    }
    .title{ 
        font-weight:bold;
        font-size: 24px;
        color: #5668ee;
    }
    .nav{
        font-size: 14px;
        font-weight: 500;
        color: #797979;
    }
`
export const LayoutHeader = () => {
    return (
        <Container align="middle">
            <Col className="title" span={8}>
                <Row gutter={[16, 0]} justify="start" align="middle">
                    <Col>Osins low code</Col>
                </Row>
            </Col>
            <Col className="nav" span={16}>
                <Row align="middle">
                    <Col span={16} >
                        <Row gutter={[16, 0]} align="middle">
                            <Col>解决方案</Col>
                            <Col>开发文档</Col>
                            <Col>团队日志</Col>
                            <Col>服务报价</Col> 
                        </Row>
                    </Col>
                    <Col span={8}>
                        <Row justify="end" align="middle">
                            <Col>
                                <Button type="primary" shape="round">
                                    登录
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Container>
    )
}